<template>
  <v-container v-if="loading">
    <div class="text-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      Vykdomas duomenų užkrovimas
    </div>
    <v-skeleton-loader v-bind="attrs" type="article"></v-skeleton-loader>
  </v-container>
</template>

<script>
export default {
  name: 'ElTurtasLoading',
  props: {
    loading: Boolean,
  },
  data() {
    return {
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 0,
      },
    }
  },
}
</script>

<style lang="scss" scoped></style>
